<template>
  <a-config-provider :locale="locale">
    <router-view />
    <global-setting />

    <!-- 全局抽屉组件 -->
    <ReportDrawer
      :drawer-visible="drawerStore.activeReportDrawer"
      :customer-info="drawerStore.reportParams"
      @update:drawer-visible="drawerStore.closeReportDrawer()"
    />
    <CustomerDrawer
      :drawer-visible="drawerStore.activeCustomerDrawer"
      :member-info="drawerStore.customerParams"
      @update:drawer-visible="drawerStore.closeCustomerDrawer()"
    />
    <AddCustomerDrawer
      :visible="drawerStore.activeAddCustomerDrawer"
      v-bind="drawerStore.addCustomerParams"
      @update:visible="drawerStore.closeAddCustomerDrawer()"
      @success="
        () => {
          if (drawerStore.addCustomerParams?.onSuccessCallback) {
            drawerStore.addCustomerParams.onSuccessCallback();
          }
        }
      "
    />
    <ReportMsgDrawer
      :drawer-visible="drawerStore.activeReportMsgDrawer"
      :report-id="drawerStore.reportMsgId"
      @update:drawer-visible="drawerStore.closeReportMsgDrawer()"
    />
  </a-config-provider>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import enUS from '@arco-design/web-vue/es/locale/lang/en-us';
  import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn';
  import GlobalSetting from '@/components/global-setting/index.vue';
  import useLocale from '@/hooks/locale';
  import { useDrawerStore } from '@/store';

  const drawerStore = useDrawerStore();

  const { currentLocale } = useLocale();
  const locale = computed(() => {
    switch (currentLocale.value) {
      case 'zh-CN':
        return zhCN;
      case 'en-US':
        return enUS;
      default:
        return enUS;
    }
  });
</script>
